import React from 'react';
import { EnvModel } from '../../../modules/env/model';

/**
 * A component to wrap client only components
 * i.e. components which use browser only functionality like useLayoutEffect
 */
const ClientOnly = ({ children }) => {
  if (EnvModel.isServer && !process.env.VITEST) return null;

  return <>{children}</>;
};

export default ClientOnly;
